import React from "react";
import { Box, Heading, Text, Grid, GridItem, Center, Image, VStack } from "@chakra-ui/react";

import GreenPaw from "../../assets/green-paw.png";
import OrangePaw from "../../assets/orange-paw.png";
import PackLeader from "../../assets/pack-leader.png";
import { lightGreen, primaryGreen } from "../../constants";

export const AboutPackLeader = () => {
  return (
    <Box bg="white" as="section" py={{ base: 12, md: 20 }} pos="relative">
      <Box maxW="7xl" mx="auto" px={6}>
        <Grid templateColumns={{ base: "1fr", md: "0.7fr 1fr" }} gap={20}>
          <GridItem>
            <Center h="100%">
              <Image width="100%" height="auto" borderRadius="lg" aspectRatio={1} src={PackLeader} alt="Sarah Squire" />
            </Center>
          </GridItem>
          <GridItem>
            <VStack align="flex-start" justify="center" spacing={6}>
              <Heading as="h2" size="lg" color={lightGreen} fontFamily="'Baloo 2', sans-serif">
                Pack Leader
              </Heading>
              <Heading as="h2" size="xl" color={primaryGreen} fontFamily="'Baloo 2', sans-serif">
                Sarah Squire
              </Heading>
              <Text color="black" fontFamily="'Baloo 2', sans-serif" lineHeight={1.8}>
                Sarah Squire is a highly experienced and dedicated dog behaviourist with over 20 years of experience in the field, providing behavioural assessments, one-to-one training, obedience work, puppy and older dog socialisation groups, as well as working extensively with the dog charity, Every Paw Matters, as their behavioural expert.
                <br />
                <br />
                Sarah graduated with honours in Psychology and then went on to complete a post graduate certificate in education and for many years worked as a special needs teacher, supporting children with learning and behavioural difficulties.
                <br />
                <br />
                This background uniquely equips her to understand and address complex behavioural issues in both dogs and people.
              </Text>
            </VStack>
          </GridItem>
        </Grid>
        <Image src={GreenPaw} alt="Green Paw" position="absolute" top="0" right="0" w="10%" zIndex={9} />
        <Image src={OrangePaw} alt="Orange Paw" position="absolute" bottom="0" left="0" w="10%" zIndex={9} />
      </Box>
    </Box>
  );
};
